<template>
  <div class="bg-white admin-dashboard-container">
  </div>
</template>

<script>
export default {};
</script>
